import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useObject } from 'react-firebase-hooks/database'
import { useHistory } from 'react-router'
import { PopupRef } from 'src/firebaseConfig'
import routes from 'src/routes'
import Amplitude from 'src/utils/amplitudeHelper'
import styled from 'styled-components'
import { fixedAssets } from './PreCache'

const ModalWrapper = styled(Modal)`
  @keyframes blinker {
    from {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    to {
      opacity: 1;
    }
  }
  .modal-content {
    background-color: rgba(255, 255, 255, 1);
    border: none;
    border-radius: 0;

    .modal-header {
      border: none;
      padding-top: 0;
      padding-bottom: 0;
     
      .close {
        color: #000;
        opacity: 1;
        padding: 16px 0;
        font-size: 60px;
        font-weight: 400;
        text-shadow: none;
      }
    }

    .modal-body {
      img {
        width: 100%;
        cursor: pointer;
        transition: all 150ms ease-in-out;
        &:hover {
          opacity: 0.95;
          transform: scale(1.01);
        }
      }
    }
  }
`

export const LaunchContainer = () => {
  const history = useHistory()
  const [snapshot, loading, error] = useObject(PopupRef)
  const [showModal, setShowModal] = useState(true)
  
  if (!error && !loading && snapshot?.val() && localStorage.getItem('seenLaunchPopup') !== snapshot?.val()) {
    
    const visitAuditorium = () => {
      localStorage.setItem('seenLaunchPopup', snapshot?.val() || 'never')
      Amplitude.click("Live Popup Modal")
      history.push(routes.auditorium1)
    }

    return (
      <ModalWrapper backdrop="static" show={showModal} onHide={() => setShowModal(false)} centered size="lg">
        <Modal.Header closeButton>
          {/* <Modal.Title>Live Update</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <img
            src={fixedAssets.liveupdate}
            alt="Enter Auditorium Now!"
            onClick={visitAuditorium}
          />
        </Modal.Body>

        {/* <Modal.Footer>
          <button className="btn btn-danger themeBtn" onClick={visitAuditorium}>
            Enter Auditorium Now
          </button>
        </Modal.Footer> */}
      </ModalWrapper>
    )
  } else {
    return null
  }
}
